module.exports = __webpack_public_path__ + "img/03.7a941b3c.jpg";